<template>
  <div>
    <!-- <div class="phone topbox">
      <img
        style="padding-top:10px;padding-left:10px; width: 80%"
        src="@/assets/dianhua.png"
        alt="电话"
      />
      <div class="phonebox">
        <div class="phonetext">
          <p>86-571-86851681</p>
        </div>
      </div>
    </div>
    <div class="wx topbox">
      <img
        style="padding-top:10px;padding-left:10px; width: 80%"
        src="@/assets/weixin.png"
        alt="微信"
      />
      <div class="wxbox">
        <div class="wxtext">
          <p style="font-size:20px;">扫一扫</p>
          <p>一键连接咨询服务</p>
          <div class="img-one">
            <img
              src="https://img3.dzsc.com/img/web/common/appdown.png"
              alt=""
              width="140px"
              height="140px"
            />
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="backtopBox"
      :style="{
        width: width,
        display: display,
        width: width + 'px',
        height: height + 'px',
        bottom: bottom + 'px',
        right: right + 'px',
        color: color,
      }"
      @click="toTop()"
    >
      <div class="topbox">
        <img
          style="padding-top:10px;padding-left:10px; width: 80%"
          src="@/assets/fanhuidingbu.png"
          alt="返回顶部"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      display: "none",
      scrollTop: 0,
    };
  },
  props: {
    width: {
      type: Number,
      default: 30,
    },
    height: {
      type: Number,
      default: 30,
    },
    bottom: {
      type: Number,
      default: 190,
    },
    right: {
      type: Number,
      default: 30,
    },
    color: {
      type: String,
      default: "#1989fa",
    },
  },
  // 滚动监听
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
  },
  methods: {
    // 获取页面滚动距离
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 300) {
        this.display = "block";
      } else {
        this.display = "none";
      }
    },
    // 滚动重置
    toTop() {
      let t = this.scrollTop;
      let time = setInterval(() => {
        t -= 10;
        document.documentElement.scrollTop = t;
        if (t <= 0) {
          clearInterval(time);
        }
      }, 5);
      this.display = "none";
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.throttledScrollHandler);
  },
};
</script>
<style lang='less' scoped>
.phone {
  position: fixed; /* 设置固定定位 */
  right: 10px;
  bottom: 274px;
  z-index: 9999;
  cursor: pointer;
}
.phone:hover{
  position: fixed; /* 设置固定定位 */
  right: 10px;
  bottom: 274px;
  z-index: 9999;
  cursor: pointer;
  .phonebox {
    width: 194;
    height: 50px;
    position: absolute;
    right: 50px;
    top: 0px;
    display: block;
    .phonetext {
    width: 184px;
    height:50px;
    border: 1px solid gray;
    border-top: 2px solid #c93131;
    background-color: white;
    margin-right: 10px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
     font-weight: bold;
     color:#ffae00;
}
}
}
.wx {
  position: fixed; /* 设置固定定位 */
  right: 10px;
  bottom: 222px;
  z-index: 9999;
  cursor: pointer;
}
.wx:hover{
  position: fixed; /* 设置固定定位 */
  right: 10px;
  bottom: 222px;
  z-index: 9999;
  cursor: pointer;
  .wxbox {
    width: 194;
    height: 224px;
    position: absolute;
    right: 50px;
    top: 0px;
    display:block;
    .wxtext {
    width: 184px;
    height: 222px;
    border: 1px solid gray;
    border-top: 2px solid #c93131;
    background-color: white;
    margin-right: 10px;
}
}
}
.backtopBox {
  color: #eee;
  position: fixed;
  z-index: 9999;
  font-size: 30px;
  font-weight: 800;
  cursor: pointer;
}
.topbox {
  width: 50px;
  height: 50px;
  background: #222222;
  border-radius: 25%;
}
.topbox:hover {
  width: 50px;
  height: 50px;
  background: #c93131;
  border-radius: 25%;
}
.phonebox {
    width: 194;
    height: 50px;
    position: absolute;
    right: 50px;
    top: 0px;
    display:none;
    .phonetext {
    width: 184px;
    height:50px;
    border: 1px solid gray;
    border-top: 2px solid #c93131;
    background-color: white;
    margin-right: 10px;
     text-align: center;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
     color:#ffae00;
}
}
.wxbox {
    width: 194;
    height: 224px;
    position: absolute;
    right: 50px;
    top: 0px;
    display: none;
    .wxtext {
    width: 184px;
    height: 222px;
    border: 1px solid gray;
    border-top: 2px solid #c93131;
    background-color: white;
    margin-right: 10px;
}
}
.wxbox .wxtext p {
    font-size: 14px;
    font-weight: bold;
    margin-top: 10px;
    margin-left: 20px;
    font-family: 宋体;
}
.wxbox .wxtext .img-one {
    width: 150px;
    height: 140px;
    text-align: center;
    border-top: 1px solid gray;
    margin-top: 10px;
    margin-left: 20px;
}
</style>
